import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
import { AdditionalInfoItem } from './AdditionalInfoItem';

export function ProductAdditionalInformation({
  product,
}: {
  product: ProductItem;
}) {
  const { t } = useTranslation('products');
  return product.additional_information ? (
    <div className='px-5'>
      <p className='h2 mb-4' data-testid='additional-info-title'>
        {t('products:DETAIL_PAGE_ADDITIONAL_INFORMATION_TITLE')}
      </p>
      <ul className='mb-12'>
        {product.additional_information.map((item, index) => {
          return <AdditionalInfoItem item={item} key={index} />;
        })}
      </ul>
    </div>
  ) : null;
}
